export default "__VITE_ASSET__ByaKfvE6__"